import {
  TextField,
  Box,
  Typography,
  FormControl,
  FormLabel,
  Button,
  Paper,
  IconButton,
  FormControlLabel,
  Tooltip,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
} from "@mui/material";
import dayjs from "dayjs";

import Listviewpopup from "../Lookup";
import Popup from "../popup";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Field, Formik } from "formik";
// import { CheckBox } from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  fetchApidata,
  getFetchData,
  postApidata,
  postData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { DailyHoursTaskSchema } from "../../Security/validation";
// import { HsnSchema } from "../../Security/validation";
import { TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { formGap } from "../../../ui-components/global/utils";

const EditDailyHourstask = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  console.log(params, "--find params");

  const dispatch = useDispatch();
  var recID = params.id;
  console.log(params.filtertype,"=======");
  var id = params.filtertype;
  var mode = params.Mode;
  var accessID = params.accessID;
  var checkindate = params.Date;
  var funcname = params.FunctionDesc;
  var projname = params.ProjectDesc;
  const data = useSelector((state) => state.formApi.Data);
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const loading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const Year = sessionStorage.getItem("year");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();

  const rowData = location.state || {};
  console.log(rowData, "--rowData");

  const EMPID = sessionStorage.getItem("EmpId");
  const currentDate = new Date().toISOString().split('T')[0];
  const [datas, setDatas] = useState({
    FunctionsCode: "",
    FunctionsName: "",
    ProjectCode: "",
    ProjectName: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://ess.beyondexs.com/api/HourstaskFuntionProjectController.php",
          { DailytaskID: id },
          {
            headers: {
              Authorization:
                "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.Status === "Y" && response.data.Data.length > 0) {
          const firstItem = response.data.Data[0];
          setDatas({
            FunctionsCode: firstItem.FunctionsCode || "",
            FunctionsName: firstItem.FunctionsName || "",
            ProjectCode: firstItem.ProjectCode || "",
            ProjectName: firstItem.ProjectName || "",
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, [location.key]);

  // **************  DAILY HOUR TASK  LOOKUP  ************** //

  const [employeeLookup, SetEmployeeLookup] = useState({
    empRecordID: "",
    empCode: "",
    empName: "",
  });

  const [functionLookup, SetFunctionLookup] = useState({
    funRecordID: "",
    funCode: "",
    funName: "",
  });

  const [projectLookup, SetProjectLookup] = useState({
    proRecordID: "",
    proCode: "",
    proName: "",
  });

  const [openPopup, setIsOpenPopup] = useState(false);
  const [openEMPPopup, setOpenEMPPopup] = useState(false);
  const [openFUNPopup, setOpenFUNPopup] = useState(false);
  const [openPROPopup, setOpenPROPopup] = useState(false);

  function handleOpen(type) {
    if (type == "EMP") {
      setOpenEMPPopup(true);
    }
    if (type == "FUN") {
      setOpenFUNPopup(true);
    }
    if (type == "PRO") {
      setOpenPROPopup(true);
    }
  }
  if (openPopup == false) {
    employeeLookup.empRecordID = data.EmployeesID;
    employeeLookup.empCode = data.EmployeeCode;
    employeeLookup.empName = data.EmployeeName;

    functionLookup.funRecordID = data.FunctionsID;
    functionLookup.funCode = data.FunctionsCode;
    functionLookup.funName = data.FuntionsName;

    projectLookup.proRecordID = data.ProjectID;
    projectLookup.proCode = data.ProjectCode;
    projectLookup.proName = data.ProjectName;
  }

  const childToParent = (childdata, type) => {
    console.log(
      "🚀  file: Editproduct.jsx:288  childToParent ~ childdata:",
      childdata
    );

    if (type == "Employee") {
      SetEmployeeLookup({
        empRecordID: childdata.RecordID,
        empCode: childdata.Code,
        empName: childdata.Name,
      });
      setOpenEMPPopup(false);
      setIsOpenPopup(true);
    }
    if (type == "Function") {
      SetFunctionLookup({
        funRecordID: childdata.RecordID,
        funCode: childdata.Code,
        funName: childdata.Name,
      });
      setOpenFUNPopup(false);
      setIsOpenPopup(true);
    }
    if (type == "Project") {
      SetProjectLookup({
        proRecordID: childdata.RecordID,
        proCode: childdata.Code,
        proName: childdata.Name,
      });
      setOpenPROPopup(false);
      setIsOpenPopup(true);
    }
  };
  // ************** INITIALVALUE  ************** //
  const dailyHourTaskInitialValue = {
    code: data.Code,
    description: data.Name,
    fromtime: data.FromTime,
    totime: data.ToTime,
    status:  mode ==  "A"? "N":data.Status,
    comment: data.Comments,
     sortOrder: data.SortOrder,
    disable: data.Disable === "Y" ? true: false,
  };

  const DHTSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "update";
    var isCheck = "N";
    if (values.disable == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      Code: values.code,
      Name: values.description,
      FromTime: values.fromtime,
      ToTime: values.totime,
      Status: values.status,
      //Comments: values.comment,
      Comments: values.comment.replace(/\s+/g, ' ').trim(),
      SortOrder: "0",
      Disable: isCheck,
      EmpDate: values.empDate || 0,
      //EmployeesID: employeeLookup.empRecordID,
      EmployeesID: EMPID,
      //FunctionsID: functionLookup.funRecordID,
      //ProjectID: projectLookup.proRecordID,
      parentID: params.parentID,
    };

    const response = await dispatch(postData({ accessID, action, idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate(
        -1
        // `/Apps/Secondarylistview/TR134/Daily%20Hour%20Task/${params.filtertype}/${params.parentID}/${params.Date}/${params.FunctionDesc}/${params.ProjectDesc}`,{state:rowData}
      );
    } else {
      toast.error(response.payload.Msg);
    }
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(
            `/Apps/Secondarylistview/TR134/Daily%20Hour%20Task/${params.filtertype}/${params.parentID}/${params.Date}/${params.FunctionDesc}/${params.ProjectDesc}`
          );
        }
      } else {
        return;
      }
    });
  };

  return (
    <React.Fragment>
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>

      <Box display="flex" justifyContent="space-between" p={2}>
        <Box display="flex" borderRadius="3px" alignItems="center">
          {broken && !rtl && (
            <IconButton onClick={() => toggleSidebar()}>
              <MenuOutlinedIcon />
            </IconButton>
          )}

          <Breadcrumbs
            maxItems={2}
            aria-label="breadcrumb"
            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
          >
            <Typography
              variant="h5"
              color="#0000D1"
              sx={{ cursor: "default" }}
              onClick={() => {
                navigate("/Apps/TR123/Check%20In",{state:rowData});
              }}
            >
              {mode === "E" ? `Check In(${rowData.EmpDTName})` : `Check In(${params.FunctionDesc})`}

            
            </Typography>
            <Typography
              variant="h5"
              color="#0000D1"
              sx={{ cursor: "default" }}
              onClick={() => {
                navigate(`/Apps/Secondarylistview/TR132/DailyTask/${params.filtertype}/${params.Date}`,{state:rowData});
              }}
            >
{mode === "E" ? `Daily Task(${rowData.DTCheckinDate})` : `Daily Task(${params.Date})`}


            </Typography>
            <Typography
              variant="h5"
              color="#0000D1"
              sx={{ cursor: "default" }}
              onClick={() => {
                navigate(
                  `/Apps/Secondarylistview/TR134/Daily%20Hour%20Task/${params.filtertype}/${params.parentID}/${params.Date}/${params.FunctionDesc}/${params.ProjectDesc}`
                );
              }}
            >
          {mode === "E" ? ` Daily Hour Task` : " Daily Hour Task(New)"}

      
            </Typography>
            {/* <Typography variant="h5" color="#0000D1" sx={{ cursor: "default" }}>
              {checkindate}
            </Typography> */}
          </Breadcrumbs>
        </Box>
        <Box display="flex">
          <Tooltip title="Close">
            <IconButton onClick={() => fnLogOut("Close")} color="error">
              <ResetTvIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Logout">
            <IconButton color="error" onClick={() => fnLogOut("Logout")}>
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      </Paper>
      {!loading ? (
        //  <Box m=" 20px">
        <Paper elevation={3} sx={{ margin: "10px" }}>

          <Formik
            initialValues={dailyHourTaskInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                DHTSaveFn(values);
              }, 100);
            }}
            validationSchema={DailyHoursTaskSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                   <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumn: "span 2"
                      }}
                    >
                      {/* <TextField
                        id="funCode"
                        label="Function"
                        variant="standard"
                        value={functionLookup.funCode}
                        //value={datas.FunctionsCode}
                        focused
                        required
                        inputProps={{ tabIndex: "-1" }}
                      />
                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleOpen("FUN")}
                        //disabled
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton> */}

                      <TextField
                        id="funDesc"
                        variant="standard"
                        label="Function"
                        //value={functionLookup.funName}
                        //value={datas.FunctionsName}
                        value = {funcname}
                        fullWidth
                        inputProps={{ tabIndex: "-1" }}
                        focused
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumn: "span 2"
                      }}
                    >
                      {/* <TextField
                        id="proCode"
                        label="Project"
                        variant="standard"
                        value={projectLookup.proCode}
                        //value={datas.ProjectCode}
                        focused
                        required
                        inputProps={{ tabIndex: "-1" }}
                      />
                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleOpen("PRO")}
                        //disabled
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton> */}

                      <TextField
                        id="proDesc"
                        variant="standard"
                        label="Project"
                        //value={projectLookup.proName}
                        //value={datas.ProjectName}
                        value = {projname}
                        fullWidth
                        inputProps={{ tabIndex: "-1" }}
                        focused
                      />
                    </Box> 
                    
                    <TextField
                      name="fromtime"
                      type="time"
                      id="fromtime"
                      label="From"
                      inputFormat="HH:mm:aa"
                      value={values.fromtime}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      focused
                      sx={{gridColumn: "span 2"}}
                    />
                    <TextField
                      name="totime"
                      type="time"
                      id="totime"
                      label="To"
                      inputFormat="HH:mm:aa"
                      value={values.totime}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      focused
                      sx={{gridColumn: "span 2"}}
                    />

                  
                   
                    <TextField
                     name="comment"
                      type="text"
                      id="comment"
                      label="Comment"
                      multiline
                      rows={6}
                      variant="outlined"
                      fullWidth
                      focused
                      required
                      value={values.comment} 
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!touched.comment && !!errors.comment}
                      helperText={touched.comment && errors.comment}
                      sx={{gridColumn: "span 2"}}
                    />
                    <FormControl
                      focused
                      variant="standard"
                      sx={{ gridColumn: "span 2" }}
                    >
                      <InputLabel id="status">Status</InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="status"
                        name="status"
                        value={values.status||"N"}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      >
                        <MenuItem value="N">Not yet started</MenuItem>
                        <MenuItem value="I">Inprogress</MenuItem>
                        <MenuItem value="C">Completed</MenuItem>
                        <MenuItem value="T">Transfer to</MenuItem>
                      </Select>
                    </FormControl>

                    {values.status == "T" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2"
                        }}
                      >
                        <TextField
                          id="empCode"
                          label="Employee"
                          variant="standard"
                          value={employeeLookup.empCode}
                          focused
                          required
                          inputProps={{ tabIndex: "-1" }}
                        />
                        <IconButton
                          sx={{ height: 40, width: 40 }}
                          onClick={() => handleOpen("EMP")}
                        >
                          <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                        </IconButton>

                        <TextField
                          id="empDesc"
                          variant="standard"
                          value={employeeLookup.empName}
                          fullWidth
                          inputProps={{ tabIndex: "-1" }}
                          focused
                        />
                      </Box>
                    ) : (
                      false
                    )}
                      {values.status == "T" ? (
                    
                              <TextField
                                name="empDate"
                                type="date"
                                id="empDate"
                                label="Transfer Date"
                                inputFormat="YYYY-MM-DD"
                                variant="standard"
                                focused
                                value={values.empDate}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.empDate && !!errors.empDate}
                                helperText={touched.empDate && errors.empDate}
                                sx={{ gridColumn: "span 2" }}
                              />
                  ) : (
                    false
                  )}
                    
                  
                </Box>
                <Box display="flex" padding={1} justifyContent="end" mt="-30px" gap="20px">
                  {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      onClick={() => {
                        DHTSaveFn(values, resetForm);
                        //navigate(`/Apps/Secondarylistview/TR134/Daily%20Hour%20Task/${params.filtertype}/${params.parentID}/${params.Date}`);
                      }}
                    >
                      Save
                    </LoadingButton>
                  {/* ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )} */}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate(
                        -1
                        // `/Apps/Secondarylistview/TR134/Daily%20Hour%20Task/${params.filtertype}/${params.parentID}/${params.Date}/${params.FunctionDesc}/${params.ProjectDesc}`
                      );
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <Popup
            title="Function"
            openPopup={openFUNPopup}
            setOpenPopup={setOpenFUNPopup}
          >
            <Listviewpopup
              accessID="2048"
              screenName="Function"
              childToParent={childToParent}
            />
          </Popup>
          <Popup
            title="Project"
            openPopup={openPROPopup}
            setOpenPopup={setOpenPROPopup}
          >
            <Listviewpopup
              accessID="2054"
              screenName="Project"
              childToParent={childToParent}
            />
          </Popup>
          <Popup
            title="Employee"
            openPopup={openEMPPopup}
            setOpenPopup={setOpenEMPPopup}
          >
            <Listviewpopup
              accessID="2024"
              screenName="Employee"
              childToParent={childToParent}
            />
          </Popup>
        {/* </Box> */}
             </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default EditDailyHourstask;
